export default class ConnectorResults {
    items = [];
    res = {};
    constructor(items, res) {
        this.items = items;
        this.res = res;
    }
}
//# sourceMappingURL=connectorResults.js.map